module.exports = __webpack_public_path__ + "static/media/Oxygen_customer_support.1f1d6f6e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Oxygen_customer_support.jpg
// module id = 653
// module chunks = 0